/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Val_TiffInputs */

const en_val_tiff = /** @type {(inputs: Val_TiffInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`TIFF`)
};

const es_val_tiff = /** @type {(inputs: Val_TiffInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`TIFF`)
};

const fr_val_tiff = /** @type {(inputs: Val_TiffInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`TIFF`)
};

const de_val_tiff = /** @type {(inputs: Val_TiffInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`TIFF`)
};

const ja_val_tiff = /** @type {(inputs: Val_TiffInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`TIFF`)
};

const zh_val_tiff = /** @type {(inputs: Val_TiffInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`TIFF`)
};

const ar_val_tiff = /** @type {(inputs: Val_TiffInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`TIFF`)
};

const id_val_tiff = /** @type {(inputs: Val_TiffInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`TIFF`)
};

const it_val_tiff = /** @type {(inputs: Val_TiffInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`TIFF`)
};

const ru_val_tiff = /** @type {(inputs: Val_TiffInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`TIFF`)
};

const pt_val_tiff = /** @type {(inputs: Val_TiffInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`TIFF`)
};

const ko_val_tiff = /** @type {(inputs: Val_TiffInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`TIFF`)
};

/**
* | output |
* | --- |
* | "TIFF" |
*
* @param {Val_TiffInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const val_tiff = /** @type {((inputs?: Val_TiffInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Val_TiffInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_val_tiff(inputs)
	if (locale === "es") return es_val_tiff(inputs)
	if (locale === "fr") return fr_val_tiff(inputs)
	if (locale === "de") return de_val_tiff(inputs)
	if (locale === "ja") return ja_val_tiff(inputs)
	if (locale === "zh") return zh_val_tiff(inputs)
	if (locale === "ar") return ar_val_tiff(inputs)
	if (locale === "id") return id_val_tiff(inputs)
	if (locale === "it") return it_val_tiff(inputs)
	if (locale === "ru") return ru_val_tiff(inputs)
	if (locale === "pt") return pt_val_tiff(inputs)
	return ko_val_tiff(inputs)
});